<script lang="ts" setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { authStore } from "@/store/auth";
import { useCustomRouter } from "@/utils/router";

const route = useRoute();
const { replaceIgnoreError } = useCustomRouter();

const orderId = computed(() => Number(route.params["orderId"]));
const workTimeOptionId = computed(() =>
  Number(route.params["workTimeOptionId"])
);

async function onClickNext() {
  authStore.setShouldRequireUnderstandingTest(false);
  await replaceIgnoreError({
    name: "OrdersLastConfirmation",
    params: {
      orderId: orderId.value.toString(),
      workTimeOptionId: workTimeOptionId.value.toString()
    }
  });
}
</script>

<template>
  <div class="container bg-white">
    <div class="header">
      理解度テスト
    </div>
    <div class="content">
      <div class="large-title">
        CLEAR
      </div>
      <div class="description">
        理解度テストのクリア、おめでとうございます！<br />
        ルールを守って気持ちの良いカイテクワークを楽しんでください。<br />
        ご不明点があればお気軽に運営事務局までお問い合わせください。
      </div>
      <div class="image">
        <img
          src="@/assets/svg/UnderstandingTest/CaikumaElated.svg?webp&width=200"
        />
      </div>
    </div>
    <div class="footer bg-white">
      <AppButton block class="button" @click="onClickNext"
        >最終確認へ</AppButton
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-height: 100vh;
  padding: env(safe-area-inset-top, 0) 20px 0;

  .header {
    margin-top: 40px;
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: 600;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0;
  }

  .content {
    margin-bottom: 80px;

    .large-title {
      margin-bottom: 40px;
      font-size: 64px;
      font-weight: 700;
      line-height: 83px;
      color: #fbce5a;
      text-align: center;
      letter-spacing: 0;
    }

    .description {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0;
    }

    .image {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        @media only screen and (max-height: 800px) {
          width: 140px;
          height: 162px;
          margin: 50px;
        }

        @media only screen and (min-height: 801px) {
          width: 200px;
          height: 216px;
          margin: 80px;
        }
      }
    }
  }

  .footer {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 8px 16px 28px;
  }
}
</style>
